<script>
  import AdminSelectorModal from "./AdminSelectorModal.svelte";
  import RegisterInterestConfirmationModal from "./RegisterInterestConfirmationModal.svelte";

  let registered = $state(false);
  let { license } = $props();
</script>

{#if !registered}
  <AdminSelectorModal bind:registered {license} />
{:else}
  <RegisterInterestConfirmationModal />
{/if}
